import React, { ButtonHTMLAttributes, ReactNode } from "react";
import styled from "styled-components";
import {
  defaultButtonStyle,
  styledKind,
  styledSize,
} from "~/guidelines/Button/StyledComponents";
import { KeyboardArrowDown } from "~/guidelines/Icon";

/**
 * We cannot reuse our guidelines/Button component as trigger because of incompatibility of Props with the trigger props from Menu
 * I think we should think again this system
 */
const StyledButton = styled.button<{ variant?: "dark" | "light" }>`
  ${defaultButtonStyle(false)}
  ${styledSize("normal")}
  ${styledKind("tertiary", "dark_background")}
  /** Dirty hack to ensure consistency on homepage */
  color: white;
  border-color: white;

  ${({ variant }) =>
    variant === "light" && "color: black; border-color: black;"}
`;

type TextualTriggerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: "dark" | "light";
};

const ButtonTrigger = React.forwardRef<HTMLButtonElement, TextualTriggerProps>(
  function TextualTriggerForwardRef(
    { children, variant, ...ariaProps }: TextualTriggerProps,
    ref,
  ) {
    return (
      <StyledButton
        {...ariaProps}
        ref={ref}
        className="ButtonTrigger"
        variant={variant}
      >
        {children} <KeyboardArrowDown aria-hidden="true" />
      </StyledButton>
    );
  },
);

export default ButtonTrigger;
